const scrollElem = document.querySelector('[data-scroll-to-elem]');

if (scrollElem) {
    scrollElem.addEventListener('click', (e) => {
        e.preventDefault();

        const target = document.querySelector('[data-scroll-block]');

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    });
}
